import React from 'react';
import { Form, Formik } from 'formik';
import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  InputAdornment
} from '@material-ui/core';
import FormikTextField from './FormikTextField';
import { ResourceSchema } from './validation';
import FormDialog from './FormDialog';
import SubmitButton from '../buttons/SubmitButton';
import ActionButton from '../buttons/ActionButton';
import { useCreateResource, useUpdateResource } from '../../hooks/resources';

const initialValues = {
  metadata: '',
  monthlyCost: '',
  name: '',
  type: ''
};

const ResourceForm = ({ resource, currentProject, handleClose, open }) => {
  const createResourceMutation = useCreateResource();
  const updateResourceMutation = useUpdateResource();

  const isEditMode = Boolean(resource);

  let resolvedInitialValues = {
    ...initialValues
  };
  if (isEditMode) {
    const { name, metadata, type, monthlyCost } = resource;

    resolvedInitialValues = {
      ...initialValues,
      metadata,
      monthlyCost,
      name,
      type
    };
  }

  const handleSubmit = (values, action) => {
    const options = {
      onError: handleClose,
      onSuccess: () => {
        action.resetForm();
        handleClose();
      }
    };

    if (isEditMode) {
      updateResourceMutation.mutate(
        {
          projectId: currentProject,
          resource: values,
          resourceId: resource._id
        },
        options
      );
    } else {
      createResourceMutation.mutate({ projectId: currentProject, resource: values }, options);
    }
  };

  return (
    <FormDialog fullWidth onClose={handleClose} open={open}>
      <DialogTitle>{isEditMode ? 'Edit' : 'Add'} Resource</DialogTitle>
      <Formik
        initialValues={resolvedInitialValues}
        onSubmit={handleSubmit}
        validationSchema={ResourceSchema}
      >
        {({ isSubmitting, dirty, isValid }) => (
          <Form>
            <DialogContent>
              <DialogContentText>Please fill resource information</DialogContentText>
              <FormikTextField autoFocus label="Resource Name" name="name" required />

              <FormikTextField label="Resource Type" name="type" required />

              <FormikTextField
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>
                }}
                label="Monthly Cost"
                name="monthlyCost"
                required
              />

              <FormikTextField
                label="Metadata"
                maxRows={4}
                multiline
                name="metadata"
                required
                rows={3}
              />
            </DialogContent>
            <DialogActions>
              <ActionButton onClick={handleClose} version="secondary">
                Cancel
              </ActionButton>
              <SubmitButton
                disabled={!isValid || !dirty}
                isLoading={isSubmitting}
                version="primary"
              >
                {isEditMode ? 'Update' : 'Create'}
              </SubmitButton>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </FormDialog>
  );
};

export default ResourceForm;
